import styled from "@emotion/styled";

export const LeadAssignmentsPageContainer = styled.div({
	width: "100%",
	minWidth: 0,
	overflow: "hidden"
});

export const LeadAssignmentsPageHeader = styled.h4(({ theme }) => ({
	width: "100%",
	padding: "20px 32px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	color: theme.project.colors.fontColors.main,
	margin: 0
}));

export const LeadAssignmentsPageContentContainer = styled.div({
	padding: "16px 20px",
	minWidth: 0
});

export const LeadAssignmentsPageContent = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	minWidth: 0
}));
